export function SearchSettingsDrawer({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="mt-4 flex flex-wrap justify-between items-end w-full md:w-auto gap-2 [&>*:not(:last-child)]:flex-1 [&>*:not(:last-child)]:min-w-0 [&>*:not(:last-child)]:max-w-none [&>*:last-child]:flex-none [&>*:last-child]:w-[46px] [&>*:last-child]:min-w-[46px] [&>*:last-child]:max-w-[46px] md:[&>*:not(:last-child)]:flex-initial md:[&>*:not(:last-child)]:min-w-auto md:[&>*:not(:last-child)]:max-w-full md:[&>*:last-child]:flex-initial md:[&>*:last-child]:w-auto md:[&>*:last-child]:min-w-0 **:max-w-[110px] md:**:max-w-full">
      {children}
    </div>
  );
}
